// removed by extract-text-webpack-plugin
module.exports = {"Base":"Contact__Base-2SAtT","Article":"Contact__Article-3lX6g","Header":"Contact__Header-m0e6t","Content":"Contact__Content-3FAOJ","P":"Contact__P-2MlrP"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Contact/Contact.css
 ** module id = 649
 ** module chunks = 0
 **/